import THAILAND from '../StaticData/Thailand.js';

export const getProvinceSelectOptions = () => {
  return Object.keys(THAILAND).map(key => ({
    label: THAILAND[key].name.th,
    value: key,
  })).sort((a, b) => a.label.localeCompare(b.label));
};

export const getCitySelectOptions = (province) => {
  if (!province) return [];

  const provinceData = THAILAND[province.value];

  return Object.keys(provinceData.amphoes).map(key => ({
    label: provinceData.amphoes[key].name.th,
    value: key,
  })).sort((a, b) => a.label.localeCompare(b.label));
};

export const getTownSelectOptions = (province, city) => {
  if (!province || !city) return [];

  const provinceData = THAILAND[province.value];
  const cityData = provinceData.amphoes[city.value];

  return Object.keys(cityData.tambons).map(key => ({
    label: cityData.tambons[key].name.th,
    value: key,
    zipcode: cityData.tambons[key].zipcode,
  })).sort((a, b) => a.label.localeCompare(b.label));
};

export const getProvinceFromName = (provinceName) => {
  const id = Object.keys(THAILAND).find(key => THAILAND[key].name.th === provinceName);
  return id ? { label: THAILAND[id].name.th, value: id } : null;
}

export const getCityFromName = (province, cityName) => {
  if (!province || !cityName) return null;
  const id = Object.keys(THAILAND[province.value].amphoes).find(key => THAILAND[province.value].amphoes[key].name.th === cityName);
  return id ? { label: THAILAND[province.value].amphoes[id].name.th, value: id } : null;
}

export const getTownFromName = (province, city, townName) => {
  if (!province || !city || !townName) return null;
  const id = Object.keys(THAILAND[province.value].amphoes[city.value].tambons).find(key => THAILAND[province.value].amphoes[city.value].tambons[key].name.th === townName);
  return id ? { label: THAILAND[province.value].amphoes[city.value].tambons[id].name.th, value: id } : null;
}